import BCComponent from "./bc_component";
import {bindActionCreators} from "redux";
import {getBonusTasks, submitBonusTask} from "game/app/actions/bonus-tasks-actions";
import connect from "react-redux/es/connect/connect";
import React from "react";

class Oblast4 extends BCComponent {

    render() {
        return (
            <div>
                <h3>Oblast 4 – AUDIO-VIDEO</h3>
                <div className='separate-bottom'>
                    <p>Videa mohou být moderním nástrojem pro vzdělávání či osobní rozvoj. Na internetu najdete nepřeberné množství videí - ať už inspirativních nebo vzdělávacích. I zde je ale zapotřebí dobře vybírat - některá videa totiž slouží jenom pro zábavu. Výhodou videa je spojení různých vjemů - vnímají při něm uši i oči. A to, ať už se jedná o klasické video nebo o komentované statické obrázky.</p>
                    <p>Pokud video sami vytvoříte, osvojíte si další dovednosti a proniknete do tématu z jiného pohledu.</p>
                </div>

                <h4>Znalostní úkoly</h4>
                { this.showTask('audio_video_1') }
                { this.showTask('audio_video_2') }
                {/* { this.showTask('audio_video_5') }                 */}

                <h4>Tvořivé úkoly</h4>
                { this.showTask('audio_video_3') }
                { this.showTask('audio_video_4') }
                {/* { this.showTask('audio_video_6') }  */}

            </div>
        );
    }
}

function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Oblast4);
